module.exports = __webpack_public_path__ + "img/push.bdb31ba8.svg";